module.exports = __webpack_public_path__ + "static/media/admin.5c71b77d.svg";